import { Download, QrCode } from "@mui/icons-material";
import {
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  LinearProgress,
} from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import ConfirmAndCancelButtons from "../../../../../components/buttons/ConfirmAndCancelButtons";
import {
  useDownloadQrCode,
  useQrCodeSvg,
} from "../../../../../hooks/useQrCode";
import { useIsMobile } from "../../../../../utils/Functions";
import LargeWarningDisplay from "./LargeWarningDisplay";
import QrCodeDisplay from "./QrCodeDisplay";
const QR_CONTENT_HEIGHT = 390;

export default function QrCodeDialog({ clinicId, targetPath }) {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const {
    data: imageData,
    isLoading: isLoadingImage,
    error,
  } = useQrCodeSvg(clinicId);
  const { downloadQrCode, isLoading: isDownloading } = useDownloadQrCode();

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const isConfirmDisabled =
    isDownloading || isLoadingImage || !!error || !clinicId;

  const handleDownload = () => {
    if (clinicId) {
      downloadQrCode(clinicId);
    }
  };
  return (
    <>
      <IconButton
        onClick={handleOpen}
        title={t("ShowQrCode")}
        data-testid="clinic.qr.trigger"
      >
        <QrCode size={20} />
      </IconButton>

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="xs"
        PaperProps={{ "data-testid": "clinic.qr.dialog" }}
      >
        <DialogTitle>
          {t("ClinicQrCodeTitle")}
          <Divider sx={{ mt: 0.5 }} />
        </DialogTitle>

        <DialogContent
          sx={{
            px: isMobile ? 2 : 3,
            py: 1,
            minHeight: QR_CONTENT_HEIGHT,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          {isLoadingImage ? (
            <LinearProgress />
          ) : error ? (
            <LargeWarningDisplay
              title="QrCodeLoadError"
              message="ErrorFetchingQrCode"
              testId="clinic.qr.no-link-warning"
            />
          ) : (
            <QrCodeDisplay
              imageData={imageData}
              targetUrl={targetPath}
              testIdPrefix="clinic.qr"
            />
          )}
        </DialogContent>

        <DialogActions>
          <ConfirmAndCancelButtons
            cancelTitle="Cancel"
            confirmTitle="Download"
            onCancel={() => handleClose()}
            onConfirm={() => handleDownload()}
            testId="clinic.qr"
            confirmButtonProps={{
              disabled: isConfirmDisabled,
              startIcon: isDownloading ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                <Download />
              ),
            }}
          />
        </DialogActions>
      </Dialog>
    </>
  );
}
